import amplitude from 'tools/amplitude/amplitude';

import type { LogPrintSetupParams } from './analytic.model';

function logPrintSetup(eventParams: LogPrintSetupParams) {
  amplitude.logEvent('PRINTER_SETUP', {
    PARTNER_ID: eventParams.partnerId,
    PRINTER_STATUS: eventParams.command.toString(),
    PRINTS_CHECKLIST: eventParams.checklist.toString(),
    AUTOMATIC_PRINTER_TICKET: eventParams.autoPrint.toString(),
  });
}

export const orderPrintingConfigAnalytic = {
  logPrintSetup,
};
